export const gHomeDatas =
    [
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 1,
            "ModelName": "商城屏保",
            "ModelCode": "WelCome",
            "IsDisplay": true,
            "SortBy": 99,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 2,
            "ModelName": "当前门店",
            "ModelCode": "CurrentVpn",
            "IsDisplay": true,
            "SortBy": 1,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": [
                {
                    "BannerId": null,
                    "Id": "fa704877-7124-4ada-89fd-1d07e74e4413",
                    "Name": null,
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446009979208651.jpg",
                    "DetailImage": "",
                    "BackgroundImage": "",
                    "Link": null,
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 0,
                    "SortBy": null
                },
                {
                    "BannerId": null,
                    "Id": "09c000a4-7c16-447c-a48c-664d185b8556",
                    "Name": null,
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637436384816969679.jpg",
                    "DetailImage": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637436384883068964.jpg",
                    "BackgroundImage": "",
                    "Link": null,
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 0,
                    "SortBy": null
                },
                {
                    "BannerId": null,
                    "Id": "9269fd27-3c79-4637-b3c2-b26365589197",
                    "Name": null,
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446009850854113.jpg",
                    "DetailImage": "",
                    "BackgroundImage": "",
                    "Link": null,
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 0,
                    "SortBy": null
                }
            ],
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 4,
            "ModelName": "首页横幅",
            "ModelCode": "Banner",
            "IsDisplay": true,
            "SortBy": 2,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": [
                {
                    "BannerId": "9af7847e-f792-4c96-a169-2d6b48e28a95",
                    "Id": null,
                    "Name": "积分",
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446028845294409.png",
                    "DetailImage": null,
                    "BackgroundImage": null,
                    "Link": "http://wx.goldensoftcn.com/page1/index.html#/Integral/IntegralMall",
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 4,
                    "SortBy": null
                },
                {
                    "BannerId": "7683a12d-e108-4c53-8e8f-35b3252b3f91",
                    "Id": null,
                    "Name": "优惠券",
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446030746500225.png",
                    "DetailImage": null,
                    "BackgroundImage": null,
                    "Link": "http://wx.goldensoftcn.com/page1/index.html#/MyCoupon/MyCoupon",
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 4,
                    "SortBy": null
                },
                {
                    "BannerId": "e579dcf8-7ddf-455d-b430-a1c9d5bed3f5",
                    "Id": null,
                    "Name": "分销",
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446030433128817.png",
                    "DetailImage": null,
                    "BackgroundImage": null,
                    "Link": "http://wx.goldensoftcn.com/page1/index.html#/Salesperson/EveryoneSalesman/Null",
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 4,
                    "SortBy": null
                },
                {
                    "BannerId": "8dacdb58-02b1-4709-9006-ad05371b5438",
                    "Id": null,
                    "Name": "会员",
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446026483543565.png",
                    "DetailImage": null,
                    "BackgroundImage": null,
                    "Link": "http://wx.goldensoftcn.com/page1/index.html#/Public/MyMembershipCard",
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 4,
                    "SortBy": null
                }
            ],
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 5,
            "ModelName": "快捷导航",
            "ModelCode": "ImageNav",
            "IsDisplay": true,
            "SortBy": 3,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":1,\"ColumnNum\":4,\"ShowCut\":null,\"GoodsId\":null}",
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 4,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": [
                {
                    "BannerId": "6e9f964c-d4f4-4530-b46a-be1860703e85",
                    "Id": null,
                    "Name": "测试",
                    "Thumbnail": "http://images01.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637526999312193571.png",
                    "DetailImage": null,
                    "BackgroundImage": null,
                    "Link": null,
                    "AppLink": null,
                    "ShortId": null,
                    "Mode": 11,
                    "SortBy": 1
                }
            ],
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 6,
            "ModelName": "卡片导航",
            "ModelCode": "CardImageNav",
            "IsDisplay": true,
            "SortBy": 4,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":2,\"ColumnNum\":2,\"ShowCut\":null,\"GoodsId\":null}",
            "VpnName": "九号温泉",
            "RowNum": 2,
            "ColumnNum": 2,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 7,
            "ModelName": "门店信息",
            "ModelCode": "VpnInfo",
            "IsDisplay": true,
            "SortBy": 5,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":1,\"ColumnNum\":1,\"ShowCut\":null,\"GoodsId\":null,\"DisplayMode\":null}",
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 1,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": [
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "ea4f2022-eebc-468c-b883-5d4a55d7eb10",
                    "GoodsId": "00729",
                    "CategoryId": null,
                    "GoodType": "goods",
                    "ShowSaleNumber": true,
                    "GoodsName": "皮尔卡丹真丝袍789",
                    "GoodsTag": null,
                    "DefaultMoney": 789,
                    "Price": 700,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": null,
                    "Number": 2,
                    "VirtualSaleCount": 0,
                    "SortBy": 1,
                    "StartTime": "2021-03-18T16:39:57",
                    "EndTime": "2021-03-18T16:39:57",
                    "StatusMsg": "已结束",
                    "SurplusNum": 18,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": null,
                    "PromotionRules": null,
                    "CustomerOrientedType": null,
                    "PromotionPlanId": null,
                    "WaiverAmount": null,
                    "CollogeMemberCount": 0,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": null,
                    "SaleEnd": null
                },
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "2b807235-9528-4969-a54e-e09f8a8bc6ad",
                    "GoodsId": "41",
                    "CategoryId": null,
                    "GoodType": "ticket",
                    "ShowSaleNumber": true,
                    "GoodsName": "24小时儿童89元",
                    "GoodsTag": null,
                    "DefaultMoney": 89,
                    "Price": 38,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637578389167469682.png",
                    "Number": 3,
                    "VirtualSaleCount": 0,
                    "SortBy": 2,
                    "StartTime": "2021-05-01T00:00:00",
                    "EndTime": "2021-05-01T00:00:00",
                    "StatusMsg": "进行中",
                    "SurplusNum": 47,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": null,
                    "PromotionRules": null,
                    "CustomerOrientedType": null,
                    "PromotionPlanId": null,
                    "WaiverAmount": null,
                    "CollogeMemberCount": 0,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": null,
                    "SaleEnd": null
                }
            ],
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 8,
            "ModelName": "限时抢购",
            "ModelCode": "RushBuy",
            "IsDisplay": true,
            "SortBy": 7,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":1,\"ColumnNum\":2,\"ShowCut\":null,\"GoodsId\":null,\"DisplayMode\":null}",
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 2,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": [
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "08405fef-8332-41b5-a72d-fcc6bf6af82f",
                    "GoodsId": "00704",
                    "CategoryId": null,
                    "GoodType": "goods",
                    "ShowSaleNumber": false,
                    "GoodsName": "富妮莱睡衣359",
                    "GoodsTag": null,
                    "DefaultMoney": 359,
                    "Price": 280,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637449449241368147.jpg",
                    "Number": 0,
                    "VirtualSaleCount": 0,
                    "SortBy": 1,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": null,
                    "PromotionRules": null,
                    "CustomerOrientedType": null,
                    "PromotionPlanId": null,
                    "WaiverAmount": null,
                    "CollogeMemberCount": 2,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": null,
                    "SaleEnd": null
                }
            ],
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 9,
            "ModelName": "拼团",
            "ModelCode": "GroupBuy",
            "IsDisplay": true,
            "SortBy": 8,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 1,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": [],
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 10,
            "ModelName": "砍价",
            "ModelCode": "Bargain",
            "IsDisplay": true,
            "SortBy": 9,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 1,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 11,
            "ModelName": "照片墙",
            "ModelCode": "PhotoWalls",
            "IsDisplay": true,
            "SortBy": 10,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":0,\"ColumnNum\":0,\"ShowCut\":null,\"GoodsId\":null,\"DisplayMode\":0}",
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": 0,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": [
                {
                    "CategoryId": "65deaea1-88b5-42a7-93e9-6d41951112d0",
                    "CategoryName": "商品",
                    "SortBy": 0
                },
                {
                    "CategoryId": "bbaef232-98ea-47a0-9570-40666f39d475",
                    "CategoryName": "门票",
                    "SortBy": 1
                }
            ],
            "GoodsList": [
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "00000000-0000-0000-0000-000000000000",
                    "GoodsId": "00704",
                    "CategoryId": "65deaea1-88b5-42a7-93e9-6d41951112d0",
                    "GoodType": "goods",
                    "ShowSaleNumber": true,
                    "GoodsName": "富妮莱睡衣359(限时特价买过路过不要错过)",
                    "GoodsTag": null,
                    "DefaultMoney": 359,
                    "Price": 359,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446016641007423.png",
                    "Number": 1,
                    "VirtualSaleCount": 0,
                    "SortBy": null,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": "",
                    "PromotionRules": null,
                    "CustomerOrientedType": "",
                    "PromotionPlanId": null,
                    "WaiverAmount": 0,
                    "CollogeMemberCount": 0,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": null,
                    "SaleEnd": null
                },
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "00000000-0000-0000-0000-000000000000",
                    "GoodsId": "00729",
                    "CategoryId": "65deaea1-88b5-42a7-93e9-6d41951112d0",
                    "GoodType": "goods",
                    "ShowSaleNumber": true,
                    "GoodsName": "皮尔卡丹真丝袍789",
                    "GoodsTag": "商家推荐",
                    "DefaultMoney": 789,
                    "Price": 789,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446016051160555.png",
                    "Number": 2,
                    "VirtualSaleCount": 0,
                    "SortBy": null,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": "",
                    "PromotionRules": null,
                    "CustomerOrientedType": "",
                    "PromotionPlanId": null,
                    "WaiverAmount": 0,
                    "CollogeMemberCount": 0,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": null,
                    "SaleEnd": null
                },
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "00000000-0000-0000-0000-000000000000",
                    "GoodsId": "107",
                    "CategoryId": "bbaef232-98ea-47a0-9570-40666f39d475",
                    "GoodType": "ticket",
                    "ShowSaleNumber": true,
                    "GoodsName": "冬季门票139元",
                    "GoodsTag": null,
                    "DefaultMoney": 169,
                    "Price": 139,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446000267366201.jpg",
                    "Number": 32,
                    "VirtualSaleCount": 0,
                    "SortBy": null,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": true,
                    "PromotionPlanName": "冬季门票买1送2",
                    "PromotionRules": [
                        {
                            "$id": "6",
                            "Id": "458886de-fead-4111-8ab0-58a3d366f69b",
                            "Condition": 1,
                            "Value": 2,
                            "TicketTypeId": null,
                            "Tag": "买1送2",
                            "Describe": "单品购买满1件，立送2件",
                            "Number": 0
                        }
                    ],
                    "CustomerOrientedType": "0",
                    "PromotionPlanId": "1001",
                    "WaiverAmount": 0,
                    "CollogeMemberCount": 0,
                    "ValidStart": "2021-03-06T14:52:10",
                    "ValidEnd": "2021-10-01T14:52:14",
                    "SaleStart": "2021-03-06T17:19:55",
                    "SaleEnd": "2021-06-30T00:00:00"
                },
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "00000000-0000-0000-0000-000000000000",
                    "GoodsId": "108",
                    "CategoryId": "bbaef232-98ea-47a0-9570-40666f39d475",
                    "GoodType": "ticket",
                    "ShowSaleNumber": true,
                    "GoodsName": "足疗套票299元",
                    "GoodsTag": null,
                    "DefaultMoney": 299,
                    "Price": 299,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637446001169046771.jpg",
                    "Number": 1,
                    "VirtualSaleCount": 0,
                    "SortBy": null,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": true,
                    "PromotionPlanName": "",
                    "PromotionRules": null,
                    "CustomerOrientedType": "0",
                    "PromotionPlanId": "1002",
                    "WaiverAmount": 0,
                    "CollogeMemberCount": 0,
                    "ValidStart": null,
                    "ValidEnd": null,
                    "SaleStart": "2020-12-23T17:21:15",
                    "SaleEnd": "2021-10-24T17:21:11"
                },
                {
                    "ActivityId": null,
                    "ActivityName": null,
                    "Id": "00000000-0000-0000-0000-000000000000",
                    "GoodsId": "40",
                    "CategoryId": "bbaef232-98ea-47a0-9570-40666f39d475",
                    "GoodType": "ticket",
                    "ShowSaleNumber": true,
                    "GoodsName": "18小时门票139元",
                    "GoodsTag": null,
                    "DefaultMoney": 139,
                    "Price": 139,
                    "MemberPrice": null,
                    "UseMemberPrice": false,
                    "Thumbnail": "http://images02.wechat.goldenyun.cn/wx/599193e9-244b-4e2a-8124-6e0d333aad42/637445998381627521.jpg",
                    "Number": 3,
                    "VirtualSaleCount": 0,
                    "SortBy": null,
                    "StartTime": null,
                    "EndTime": null,
                    "StatusMsg": null,
                    "SurplusNum": null,
                    "GoodsDetailExplain": null,
                    "IsShowPromotion": false,
                    "PromotionPlanName": "",
                    "PromotionRules": null,
                    "CustomerOrientedType": "",
                    "PromotionPlanId": null,
                    "WaiverAmount": 0,
                    "CollogeMemberCount": 0,
                    "ValidStart": "2020-12-26T17:16:19",
                    "ValidEnd": null,
                    "SaleStart": "2020-12-25T17:16:04",
                    "SaleEnd": "2021-07-25T17:16:06"
                }
            ],
            "MemberPriceList": [],
            "SpecificationList": [],
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": "Classic",
            "ModelId": 12,
            "ModelName": "全部商品",
            "ModelCode": "Goods",
            "IsDisplay": true,
            "SortBy": 11,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":1,\"ColumnNum\":2,\"ShowCut\":\"show\",\"GoodsId\":null,\"DisplayMode\":null}",
            "VpnName": "九号温泉",
            "RowNum": 1,
            "ColumnNum": 2,
            "DisplayMode": null,
            "IsShowMore": true,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": {
                "GroundTypeList": [],
                "BookDateList": [
                    {
                        "Date": "2021-06-09",
                        "DateInfo": "06月09日",
                        "WeekDay": "今天"
                    },
                    {
                        "Date": "2021-06-10",
                        "DateInfo": "06月10日",
                        "WeekDay": "周四"
                    },
                    {
                        "Date": "2021-06-11",
                        "DateInfo": "06月11日",
                        "WeekDay": "周五"
                    },
                    {
                        "Date": "2021-06-12",
                        "DateInfo": "06月12日",
                        "WeekDay": "周六"
                    },
                    {
                        "Date": "2021-06-13",
                        "DateInfo": "06月13日",
                        "WeekDay": "周日"
                    },
                    {
                        "Date": "2021-06-14",
                        "DateInfo": "06月14日",
                        "WeekDay": "周一"
                    },
                    {
                        "Date": "2021-06-15",
                        "DateInfo": "06月15日",
                        "WeekDay": "周二"
                    }
                ],
                "BookDays": 7
            },
            "PageGoodsStyleMode": null,
            "ModelId": 13,
            "ModelName": "场馆预订",
            "ModelCode": "GroundBook",
            "IsDisplay": true,
            "SortBy": 12,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": null,
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        },
        {
            "NewsList": null,
            "ImageBanner": null,
            "ShortcutBanner": null,
            "CardImageCut": null,
            "RushBuyGoods": null,
            "GroupBuyGoods": null,
            "CutGoods": null,
            "CategoryList": null,
            "GoodsList": null,
            "MemberPriceList": null,
            "SpecificationList": null,
            "SpecialGoodsList": null,
            "ImageUrlList": null,
            "GroundBookModel": null,
            "PageGoodsStyleMode": null,
            "ModelId": 14,
            "ModelName": "商城评论",
            "ModelCode": "MallComments",
            "IsDisplay": true,
            "SortBy": 13,
            "IsCanEdit": false,
            "MinConfigUrl": null,
            "ConfigUrl": null,
            "CustomType": null,
            "Remark": "{\"RowNum\":0,\"ColumnNum\":0,\"ShowCut\":null,\"GoodsId\":null,\"DisplayMode\":1}",
            "VpnName": "九号温泉",
            "RowNum": 0,
            "ColumnNum": 0,
            "DisplayMode": null,
            "IsShowMore": false,
            "ImageModel": null,
            "FilesJson": null,
            "TabelShowUrl": null,
            "VpnCode": "599193e9-244b-4e2a-8124-6e0d333aad42",
            "State": 0
        }
    ]